<template lang='pug'>
article.basket(v-if="basket")
  .basket__cont.cont
    h1.basket__caption.caption Корзина
    .basket__body(v-if="basket && basket.products && basket.products.length")
      .basket__area
        basket-list(:start-products="basket.products", @change-products="setProducts")
        basket-form(
            @changeName="setName",
            @changeEmail="setEmail",
            @changePhone="setPhone",
            @changeComment="setComment",
            @send-basket="sendBasket",
            @change-agreement="setAgreement"
          )
      basket-order(:products="products", @clear-basket="clearBasket")
    template(v-else)
      p.basket__text-big.text-big
        | В корзине пока ничего нет.
        br
        | Перейдите на главную страницу или воспользуйтесь поиском, если ищете что-то конкретное
      router-link.basket__button-home.button-orange(:to="{ name: 'Home'}") На главную
  tile-list(v-if="productsPopular.length", :products="productsPopular", block-name="Рекомендуем", page='basket', @refresh-data="refreshProducts")
</template>

<script>
import '@/assets/styles/components/basket.sass'
import TileList from '../_tiles/TileList'
import BasketList from './BasketList'
import BasketOrder from './BasketOrder'
import BasketForm from './BasketForm'
import Storage from '../../assets/scripts/Storage'
import {
  basketCheckout,
  getBasket,
  refreshBasket,
  getProductsPopularForBasket,
  refreshDataWithProduct,
  removeProduct
} from '../../assets/scripts/Api'

export default {
  name: 'TheBasket',
  components: { BasketForm, BasketOrder, BasketList, TileList },
  props: { basketStart: Object },
  data () {
    return {
      basket: null,
      products: [],
      name: null,
      email: null,
      phone: null,
      comment: null,
      isAgree: false,
      productsPopular: []
    }
  },
  watch: {
    basketStart (data) {
      this.basket = data
    }
  },
  methods: {
    setProducts (products) {
      this.basket.products = products
      this.products = products
      this.checkBasket()
    },
    setName (name) {
      this.name = name
    },
    setEmail (email) {
      this.email = email
    },
    setPhone (phone) {
      this.phone = phone
    },
    setComment (comment) {
      this.comment = comment
    },
    setAgreement (isAgree) {
      this.isAgree = isAgree
    },
    async sendBasket () {
      const res = await basketCheckout(this.products, this.name, this.email, this.phone, this.comment, this.isAgree)
      if (res.status !== 'success') return this.$router.go(0)
      Storage.showThanks = true
      await this.$router.push({ name: 'Thanks' })
      refreshBasket()
      Storage.clear()
    },
    async getPopularProducts () {
      const data = await getProductsPopularForBasket()
      this.productsPopular = data
    },
    checkBasket () {
      if (!this.basket.products.length) {
        this.getPopularProducts()
      } else {
        this.productsPopular = []
      }
    },
    async clearBasket () {
      console.log('clear basket')
      const removeProductRequests = this.products.map(product => removeProduct(product.id))
      Promise.all(removeProductRequests).then(async () => {
        this.basket = await refreshBasket()
        this.products = []
        this.checkBasket()
        Storage.clear()
      })
    },
    async refreshProducts (categorySlug) {
      await refreshDataWithProduct(categorySlug)
    }
  },
  async mounted () {
    this.basket = await getBasket()
    this.checkBasket()
  }
}
</script>
